var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.activeTemplate == 'nzgmeet')?_c('nzgmeet'):(_vm.activeTemplate == 'texelmeet')?_c('texelmeet'):(_vm.activeTemplate == 'burqaa')?_c('burqaa'):(_vm.activeTemplate == 'kunzila')?_c('kunzila'):_c('fixeauDefault')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }